import { render, staticRenderFns } from "./peaChangeStatus.vue?vue&type=template&id=6191b630"
import script from "./peaChangeStatus.vue?vue&type=script&lang=js"
export * from "./peaChangeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports